import { SurveyWrapper } from "../../../../legacy/pages/survey/components/survey-wrapper";
import { SurveyCurrentStep } from "../../../../legacy/pages/survey/entities/survey-current-step";
import { ScreenTypeEnum } from "../../../../legacy/pages/survey/entities/survey-step";
import SurveyInfoScreen from "../SurveyInfoScreen/SurveyInfoScreen";

interface MobileOnboardingIntroProps {
  onContinue: () => void;
}

// Copy mirrors the onboarding blueprint intro step (onboarding-variant step_21): the
// native app consumes the welcome edge, so the survey engine can never serve it on mobile.
function buildIntroStep(onContinue: () => void): SurveyCurrentStep {
  const step = new SurveyCurrentStep();
  step.stepName = "mobile-onboarding-intro";
  step.header = { title: "icon(user-circle)", onClose: function noop() {} };
  step.body = {
    ...step.body,
    title: "Prepariamo il tuo profilo!",
    description:
      "Ora ti facciamo qualche domanda per conoscerci (e trovare anche dei bonus per te.) Bastano pochi minuti.",
    screenType: ScreenTypeEnum.INFO_SCREEN,
    extra: [
      {
        component: "alert",
        icon: "💶",
        variant: "success",
        description: "<b>+19 milioni € sbloccati </b>in benefici economici ai nostri utenti",
      },
    ],
    submit: function submitIntro() {
      onContinue();
    },
  };
  return step;
}

function MobileOnboardingIntro({ onContinue }: Readonly<MobileOnboardingIntroProps>): JSX.Element {
  const step = buildIntroStep(onContinue);
  // SurveyWrapper provides the survey look (design-system theme + white body);
  // fail-open on render errors: a broken intro must not block onboarding.
  return (
    <SurveyWrapper onError={onContinue}>
      <SurveyInfoScreen step={step} />
    </SurveyWrapper>
  );
}

export default MobileOnboardingIntro;
